{
  "actions": "Toimingud",
  "hideButtonLabel": "Kuva vähem",
  "noTags": "Puudub",
  "showAllButtonLabel": "Kuva kõik ({tagCount, number})"
}
